import { CalendarPlus, MapPin } from 'lucide-react';
import Reveal from '@/components/Reveal';

const LIBRARY_IMAGE = '/images/peabody-interior-1200.webp';
const BARCOCINA_IMAGE = '/images/barcocina.jpg';

export default function SchedulePage() {
  const events = [
    {
      id: 'friday-welcome',
      day: 'Friday',
      date: 'April 23, 2027',
      title: 'Welcome Reception',
      attire: 'Casual',
      time: '6:30–9:30 p.m.',
      location: 'Barcocina',
      address: '1629 Thames St, Baltimore, MD 21231',
      description:
        'Join us for cocktails and light bites as we kick off the wedding weekend in Fells Point.',
      image: BARCOCINA_IMAGE,
      calendar: '/calendar/lexi-james-welcome-reception.ics',
    },
    {
      id: 'saturday-ceremony',
      day: 'Saturday',
      date: 'April 24, 2027',
      title: 'Ceremony & Reception',
      attire: 'Black Tie Optional',
      time: '5:00–10:00 p.m.',
      location: 'George Peabody Library',
      address: '17 E Mt Vernon Pl, Baltimore, MD 21202',
      description: 'Ceremony followed by cocktails, dinner, and dancing.',
      image: LIBRARY_IMAGE,
      calendar: '/calendar/lexi-james-wedding.ics',
    },
  ].map((event) => ({
    ...event,
    mapsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      `${event.location}, ${event.address}`
    )}`,
  }));

  return (
    <div data-testid="schedule-page" className="weekend-page">
      <header className="page-hero weekend-hero">
        <div className="page-hero__inner">
          <div>
            <p className="eyebrow text-olive mb-4">April 23–24, 2027</p>
            <h1 className="page-title">Schedule</h1>
          </div>
          <p className="max-w-md text-xl leading-snug text-forest/75 md:text-right">
            Friday in Fells Point. Saturday at the Peabody.
          </p>
        </div>
      </header>

      <section className="weekend-events" aria-label="Wedding weekend events">
        {events.map((event, index) => (
          <article
            key={event.id}
            data-testid={`schedule-card-${event.id}`}
            className={`schedule-event schedule-event--${index === 0 ? 'waterfront' : 'library'}`}
          >
            <Reveal className="schedule-event__image">
              <img
                src={event.image}
                alt={event.title}
                loading={index === 0 ? 'eager' : 'lazy'}
                decoding="async"
              />
            </Reveal>

            <Reveal className="schedule-event__content">
              <p className="eyebrow text-olive">
                {event.day} · {event.date}
              </p>
              <h2>{event.title}</h2>

              <dl className="schedule-event__meta">
                <dt>Time</dt>
                <dd>{event.time}</dd>
                <dt>Location</dt>
                <dd>{event.location}</dd>
                <dt>Address</dt>
                <dd>{event.address}</dd>
                <dt>Attire</dt>
                <dd>{event.attire}</dd>
              </dl>

              <p>{event.description}</p>

              <div className="schedule-event__actions" aria-label={`${event.title} links`}>
                <a
                  href={event.mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="schedule-event__action"
                >
                  <MapPin size={16} strokeWidth={1.7} aria-hidden="true" />
                  Open in Maps
                </a>
                <a
                  href={event.calendar}
                  download
                  className="schedule-event__action"
                >
                  <CalendarPlus size={16} strokeWidth={1.7} aria-hidden="true" />
                  Add to Calendar
                </a>
              </div>
            </Reveal>
          </article>
        ))}
      </section>
    </div>
  );
}
